import React from 'react';
import { Field } from "formik";
import InputComponent from '../Components/DynamicForm/InputComponent';
import SelectComponent from '../Components/DynamicForm/SelectComponent';
import DateComponent from '../Components/DynamicForm/DateComponent';
import DyanamicSelectBox from "../Components/DynamicForm/DyanamicSelectBox";
import CheckboxComponent from "../Components/DynamicForm/CheckboxComponent";
import RadioButton from "./RadioButton";
import { isCharWithoutSymbol, isNumber } from '../utils/regexConstants';
const CustomComponent = (props) => {
    const { formItem, id, formData, hash, values, preFormValues, fullData ,formValues,dateFormat,autoFoucs,isOtpVerified,partner } = props;
    const code = formItem.code;
    let isValidationRequired = false;
    let isValidationRequiredData = "";
  
    let readOnly = false;
    let hide = false;
    let showOtpButton = false;

    if(code === "otp" ) {
      showOtpButton  = true;
    }
    
    if(code === "mobileNumber") {
      showOtpButton  = true;
    }

    if (
      code === "mobileNumber" ||
      code === "pan"
    ) {
      readOnly = true;
    }
  
    if (code === "pan" ||  code === "mobileNumber"  ) {
      if (preFormValues.length > 0) {
        const preData = preFormValues.filter((pre) => pre.fieldCode === code);
        if (preData.length > 0) {
          let fieldData = preData[0].fieldValue;
          if (fieldData) {
            readOnly = true;
          }
          else {
            readOnly = false;
          }
        }
        else {
          readOnly = false;
        }
      } else {
        readOnly = false;
      }
    }

    if (code === "PanNumber" ||  code === "MobileNumber"  ) {
      if (preFormValues.length > 0) {
        const preData = preFormValues.filter((pre) => pre.fieldCode === code);
        if (preData.length > 0) {
          let fieldData = preData[0].fieldValue;
          if (fieldData) {
            readOnly = true;
          }
          else {
            readOnly = false;
          }
        }
        else {
          readOnly = false;
        }
      } else {
        readOnly = false;
      }
    }

    if(code === "NameOfCompanyBusiness"){
      const dependedField = formData.filter(
        (formItem) => formItem.code === "EmploymentType"
      );
      if (dependedField && dependedField.length > 0) {
        if (values['637_name_'] === 'Self Employed' || values['637'] === '2') {
          readOnly = true;
        }
      }
    }

    

    if(code === "designation"){
      const dependedField = formData.filter(
        (formItem) => formItem.code === "EmploymentType"
      );
      if (dependedField && dependedField.length > 0) {
        if (values['637_name_'] === 'Self Employed' || values['637'] == '2') {
          readOnly = true;
        }
      }
    }


    if (
      code == "permanentAddressLine1" ||
      code == "permanentAddressLine2" ||
      code == "permanentAddressLine3" ||
      code == "PermanentZipCode" ||
      code == "PermanentCity" ||
      code == "PermanentState" 
      ) {
      const dependedField = formData.filter(
        (formItem) => formItem.code == "PermAddrSameAsResAddr"
      );
      if (dependedField && dependedField.length > 0) {
        if (values[`${dependedField[0].id}`]) {
          readOnly = true;
        }
      }
    }

    

    const requiredValidate = (value, name, type) => {
      let errorMessage;
    
      if (value == "" || !value) {
        let prefix = "Enter";
        if (type == "dropdown" || type == "search") {
          prefix = "Select";
        }
    
        errorMessage = `* Please ${prefix} ${name ? name : "Data"}`;
      }else if((type === 'text' || type === "search") && !isCharWithoutSymbol.test(value)){
        errorMessage = `Special characters not allowed`;
      }else if(type === "number" && !isNumber.test(value)){
        errorMessage = `Invalid Number`;
      }

      return errorMessage;
    };
    if (formItem.type && (formItem.type === "text" || formItem.type === "number")) {
      return (
        <>
        <Field
          autoFoucs={autoFoucs}
          successTick={code === "otp" && isOtpVerified ? true : false}
          name={id}
          component={InputComponent}
          placeholder={formItem.name}
          item={formItem}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.name, formItem.type)
              : null
          }
          readOnly={readOnly}
          formData={formData}
          type={formItem.type}
          keyboardType={formItem.type === "number" ? "numeric" : "text"}
        />
        </>
      );
    } else if (
      formItem.type &&
      formItem.type === "dropdown" &&
      formItem.fieldOptions &&
      formItem.fieldOptions.length > 0
    ) {
      return (
        <Field
          name={id}
          component={SelectComponent}
          placeholder={formItem.name}
          item={formItem}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.name, formItem.type)
              : null
          }
          formData={formData}
          search={false}
          readOnly={readOnly}
        />
      );
    } else if (formItem.type && formItem.type == "dateSelector") {
      return (
        <Field
          name={id}
          component={DateComponent}
          placeholder={formItem.name}
          item={formItem}
          formData={formData}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.name, formItem.type)
              : null
          }
          dateFormat={dateFormat}
          partner={partner}
        />
      );
    } else if (formItem.type && formItem.type == "radioButton") {
      return (
        <Field
          name={id}
          component={RadioButton}
          placeholder={formItem.name}
          item={formItem}
          formData={formData}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.value, formItem.type)
              : null
          }
        />
      );
    } else if (formItem.type && formItem.type == "search") {
      return (
        <Field
          name={id}
          component={DyanamicSelectBox}
          placeholder={formItem.name}
          item={formItem}
          formData={formData}
          hash={hash}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.name, formItem.type)
              : null
          }
          preFormValues={preFormValues}
          readOnly={readOnly}
        />
      );
    } else if (formItem.type && formItem.type == "checkbox") {
      return (
        <Field
          name={id}
          component={CheckboxComponent}
          placeholder={formItem.name}
          item={formItem}
          validate={
            isValidationRequired
              ? (value) =>
                  requiredValidate(value, formItem.name, formItem.type)
              : null
          }
          formData={formData}
          fullData={fullData}
          formValues={formValues}
          hash={hash}
        />
      );
    }
    return null;
  };

  export default CustomComponent;